<template>
  <div>
    <h3 class="text-center mb-4 mt-4">账户首页</h3>
    <!-- div class="page-title-desc text-center mb-4 mt-4">您在 云联壹云 服务中的账户信息，例如您的账号、电话和公司域名</div -->
    <a-card class="page-card" title="账户信息" hoverable>
      <div class="card-item clearfloat">
        <div class="float-left card-item-title">注册账户</div>
        <div class="float-left">{{ info.name ? info.name : '-' }}</div>
      </div>
      <div class="card-item clearfloat">
        <div class="float-left card-item-title">用户等级</div>
        <div class="float-left">{{ isAgent ? agentLevelMap[agentLevel] : customerLevelMap[level] }}</div>
      </div>
      <div class="card-item clearfloat">
        <div class="float-left card-item-title">用户姓名</div>
        <div class="float-left">
          {{ level >= 2 ? (customer.creator_name || '-') : '-' }}
        </div>
        <a-icon type="safety" class="ml-2" style="color: #18ff90;" v-if="level >= 2" />
        <a-button class="ml-2" type="link" icon="edit" size="small" @click="openUserVerifyUrl" v-else>实名认证</a-button>
      </div>
      <div class="card-item clearfloat">
        <div class="float-left card-item-title">企业名称</div>
        <div class="float-left">
          {{ level >= 3 ? (enterpriseInfo.name || '-') : '-' }}
        </div>
        <a-icon type="safety" class="ml-2" style="color: #18ff90;" v-if="level >= 3" />
        <a-button class="ml-2" type="link" icon="edit" size="small" @click="editEnterpriseName" v-else>实名认证</a-button>
      </div>
      <!-- <div class="card-item clearfloat"><div class="float-left card-item-title">公司域名</div><div class="float-left">{{ info.projectDomain }}</div></div> -->
      <!-- div class="card-item clearfloat">
        <div class="float-left card-item-title">账户余额</div>
        <div class="float-left">{{ billAccountInfo.balance.toFixed(2) }} 元</div>
        <a-tooltip title="充值">
          <a-button class="ml-2" @click="recharge">充值</a-button>
        </a-tooltip>
      </div -->
    </a-card>
    <a-card class="page-card mt-4" title="服务" hoverable>
      <div class="service-card-columns">
        <div class="service-card-col" @click="openTechSupport">
          <a-tooltip placement="top" title="技术支持">
            <icon type="mobile" style="font-size: 30px;" />
          </a-tooltip>
          <a-button type="link" size="small">购买技术支持</a-button>
          <div class="service-desc">
            按次购买开源技术支持服务，扫描二维码进入专属企业微信群进行问题咨询
          </div>
        </div>
        <!-- <div class="service-card-col" @click="openLicense">
          <a-tooltip placement="top" title="软件授权">
            <icon type="license" style="font-size: 30px;" />
          </a-tooltip>
          <a-button type="link" size="small">购买软件授权</a-button>
          <div class="service-desc">
            购买软件订阅授权，获得持续稳定的技术支持服务
          </div>
        </div> -->
        <div class="service-card-col" @click="openSaas">
          <a-tooltip placement="top" title="云管SaaS">
            <icon type="saas" style="font-size: 30px;" />
          </a-tooltip>
          <a-button type="link" size="small">访问云管控制台</a-button>
          <div class="service-desc">
            访问SAAS云管控制台，体验云管功能
          </div>
        </div>
      </div>
    </a-card>
    <a-card class="page-card mt-4" title="安全设置" hoverable>
      <div class="card-item clearfloat">
        <div class="float-left card-item-title">登录密码</div>
        <div class="float-left">*******</div>
        <router-link :to="{ name: 'EditPassword' }" tag="a" class="float-right mr-4">修改</router-link>
      </div>
      <div class="card-item clearfloat">
        <div class="float-left card-item-title">手机号</div>
        <div class="float-left">{{ mobile || '-' }}</div>
        <a href="javascript:;" class="float-right mr-4" @click="editMobile">修改</a>
      </div>
      <div class="card-item clearfloat">
        <div class="float-left card-item-title">邮箱</div>
        <div class="float-left">{{ email || '-' }}</div>
        <a href="javascript:;" class="float-right mr-4" @click="editEmail">修改</a>
      </div>
      <div class="card-item clearfloat">
        <div class="float-left card-item-title">最后登录IP</div>
        <div class="float-left">{{ info.last_login_ip || '-' }}</div>
      </div>
      <div class="card-item clearfloat">
        <div class="float-left card-item-title">最后登录时间</div>
        <div class="float-left">{{ info.last_active_at ? $moment(info.last_active_at).format('YYYY年MM月DD日 HH:mm') : '-' }}</div>
      </div>
    </a-card>
    <!-- idp-card / -->
  </div>
</template>
<script>
import { mapState } from 'vuex'
// import IdpCard from './components/IdpCard'
import { cityMap } from '@/utils/utils'
import WindowsMixin from '@/mixins/windows'
import consts from '@scope/constants/consts'

export default {
  name: 'AccountUserInfo',
  /* components: {
    IdpCard,
  }, */
  mixins: [WindowsMixin],
  data () {
    return {
      agentLevelMap: consts.agentLevelMap,
      customerLevelMap: consts.customerLevelMap,
    }
  },
  computed: {
    ...mapState('auth', {
      info: state => state.info || {},
    }),
    ...mapState('app', {
      level: state => (state.customerCapability || {}).customer_level || 0,
      certifiedStatus: state => (state.customerCapability || {}).certified_status || 'uncertified',
      customerId: state => (state.customerCapability || {}).customer_id || null,
      agentLevel: state => (state.customerCapability || {}).agent_level || 0,
      isAgent: state => (state.customerCapability || {}).is_agent || false,
      mobile: state => (state.customerCapability || {}).mobile || '',
      email: state => (state.customerCapability || {}).email || '',
      enterpriseInfo: state => state.enterpriseInfo || {},
      billAccountInfo: state => state.billAccountInfo || { balance: 0 },
      cities: state => state.cities || [],
      customer: state => state.customer || {},
    }),
    disableEdit () {
      if (this.certifiedStatus === 'certified') return true
      return false
    },
  },
  methods: {
    openUserVerifyUrl () {
      this.createDialog('UserVerifyQrcodeDialog', {
        customerId: this.customerId,
      })
    },
    openLicense () {
      this.$router.push('/account/license')
    },
    openTechSupport () {
      this.$router.push('/account/tech-support')
    },
    openSaas () {
      this.$router.push('/')
    },
    citymap (val) {
      return cityMap(this.cities, val)
    },
    editEnterpriseName () {
      this.createDialog('EditEnterpriseNameDialog')
    },
    editMobile () {
      this.createDialog('EditMobileDialog', {
        mobile: this.mobile,
        customerId: this.customerId,
      })
    },
    editEmail () {
      this.createDialog('EditEamilDialog', {
        mobile: this.mobile,
        email: this.email,
        customerId: this.customerId,
      })
    },
    recharge () {
      this.createDialog('RechargeAmountDialog', {
        from: 'account',
        refresh: () => {
          this.$store.dispatch('app/getBillAccountInfo')
        },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
  .page-title-desc {
    color: #5F6368;
    font-size: 16px;
  }
  .page-card {
    width: 838px;
    border-radius: 5px;
    margin: 0 auto;
    .card-item {
      line-height: 55px;
      border-bottom: 1px solid #e8e8e8;
      .card-item-title {
        width: 155px;
        margin-right: 15px;
      }
      .edit-btn {
        font-size: 14px;
        color: #1890ff;
        cursor: pointer;
      }
    }
  }
  .clearfloat:after{
    display: block;
    clear: both;
    content: "";
    visibility: hidden;
    height:0
  }
  .clearfloat{
    zoom:1
  }
  .service-card-columns {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 32px;
    width: 100%;
  }
  .service-card-col {
    flex: 1 1 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    padding: 16px 8px;
    transition: background 0.18s, box-shadow 0.18s;
    border-radius: 8px;
  }
  .service-card-col:hover {
    background: #f6f9fb;
    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  }
  .service-card-col > .ant-btn {
    margin-top: 8px;
    margin-bottom: 8px;
  }
  .service-desc {
    margin-top: 4px;
    color: #6b7685;
    text-align: center;
    font-size: 13px;
    line-height: 1.5;
  }
</style>
